"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var polished_1 = require("polished");
var React = __importStar(require("react"));
var media_manager_connector_1 = __importDefault(require("media-manager-connector"));
var styled_components_1 = __importStar(require("../Themes/styled-components"));
var Loader_1 = __importDefault(require("../Loader"));
var MediaManagerPhotoEditor_1 = __importDefault(require("../MediaManagerPhotoEditor"));
var MediaManagerImage_1 = __importDefault(require("../MediaManagerImage"));
var Link_1 = __importDefault(require("../Link"));
var utilities_1 = require("../utilities");
var utils_1 = require("../Input/utils");
var config_1 = __importDefault(require("../config"));
/**
 * It should be as tall as three inputs
 * @param theme
 */
var calcHeight = function (theme) {
    var height = theme.input.height * 3; // height of inputs
    height += theme.formGroup.bottomMargin * 2; // height of two form group margins
    height += theme.formGroup.labelGutter * 2; // height of two form group label margins
    height += 14 * 2; // height of two form group label font-sizes
    return height;
};
var IMAGE_HEIGHT = 140;
var Wrapper = styled_components_1.default('div')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: relative;\n  border: ", ";\n  border-radius: ", ";\n  height: ", ";\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  ", "\n"], ["\n  position: relative;\n  border: ", ";\n  border-radius: ", ";\n  height: ", ";\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  ",
    "\n"])), function (props) { return utils_1.getBorderFromProps(props); }, function (_a) {
    var theme = _a.theme;
    return polished_1.rem(theme.input.borderRadius);
}, function (_a) {
    var theme = _a.theme;
    return polished_1.rem(calcHeight(theme));
}, function (_a) {
    var theme = _a.theme, disabled = _a.disabled;
    return disabled && styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      background-color: ", ";\n    "], ["\n      background-color: ", ";\n    "])), theme.input.disabledBackground);
});
var Disabled = styled_components_1.default('div')(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: rgba(255, 255, 255, 0.7);\n  cursor: ", ";\n"], ["\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: rgba(255, 255, 255, 0.7);\n  cursor: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.input.disabledCursor;
});
var ImageContainer = styled_components_1.default('div')(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  display: flex;\n  cursor: pointer;\n  justify-content: center;\n  height: ", ";\n  margin: ", ";\n  margin-bottom: 0;\n  background: ", ";\n  align-self: normal;\n  align-items: center;\n"], ["\n  display: flex;\n  cursor: pointer;\n  justify-content: center;\n  height: ", ";\n  margin: ", ";\n  margin-bottom: 0;\n  background: ", ";\n  align-self: normal;\n  align-items: center;\n"])), polished_1.rem(IMAGE_HEIGHT), polished_1.rem(3), function (_a) {
    var theme = _a.theme;
    return theme.input.disabledBackground;
});
var Controls = styled_components_1.default('div')(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  max-width: 270px;\n  width: 100%;\n  flex: 1 0 0;\n"], ["\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  max-width: 270px;\n  width: 100%;\n  flex: 1 0 0;\n"])));
var StyledMediaManagerImage = styled_components_1.default(MediaManagerImage_1.default)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  max-height: 100%;\n"], ["\n  max-height: 100%;\n"])));
var C = function (_a) {
    var error = _a.error, disabled = _a.disabled, auth = _a.auth, value = _a.value, onChange = _a.onChange, onBlur = _a.onBlur, onFocus = _a.onFocus, restProps = __rest(_a, ["error", "disabled", "auth", "value", "onChange", "onBlur", "onFocus"]);
    var _b = React.useState(false), photoEditorOpened = _b[0], setPhotoEditorOpened = _b[1];
    var _c = React.useState(false), mediamanagerOpened = _c[0], setMediamanagerOpened = _c[1];
    var closePhotoEditor = React.useCallback(function () {
        setPhotoEditorOpened(false);
        if (onBlur) {
            onBlur(typeof value === 'undefined' ? null : value);
        }
    }, [onBlur, value]);
    var closeMediaManager = React.useCallback(function () {
        setMediamanagerOpened(false);
        if (onBlur) {
            onBlur(typeof value === 'undefined' ? null : value);
        }
    }, [onBlur, value]);
    var openMediaManager = React.useCallback(function () {
        setMediamanagerOpened(true);
    }, []);
    var openPhotoEditor = React.useCallback(function () {
        setPhotoEditorOpened(true);
    }, []);
    var handleMediaManagerFilesSelect = React.useCallback(function (files) {
        if (files.length > 0) {
            var file = files[0];
            closeMediaManager();
            if (onChange) {
                var nextValue = {
                    media_url: file.media_url,
                    public_url: file.public_url,
                };
                if (file.author) {
                    nextValue.author = file.author;
                }
                if (file.source) {
                    nextValue.source = file.source;
                }
                if (file.smarttags) {
                    nextValue.smarttags = file.smarttags;
                }
                if (file.description) {
                    nextValue.description = file.description;
                }
                onChange(nextValue);
                if (onBlur) {
                    onBlur(nextValue);
                }
            }
        }
    }, [onChange, onBlur, closeMediaManager]);
    var photoEditorSubmit = React.useCallback(function (data) {
        if (onChange && value) {
            var nextValue = __assign(__assign({}, value), { dimensions: {
                    X: data.x,
                    Y: data.y,
                    W: data.width,
                    H: data.height,
                } });
            closePhotoEditor();
            onChange(nextValue);
            if (onBlur) {
                onBlur(nextValue);
            }
        }
    }, [value, onChange, onBlur, closePhotoEditor]);
    var clear = React.useCallback(function () {
        if (onChange) {
            onChange(null);
            if (onBlur) {
                onBlur(null);
            }
        }
    }, [onChange, onBlur]);
    return (React.createElement(Wrapper, __assign({ error: !!error, focused: false, disabled: !!disabled }, restProps),
        photoEditorOpened && (React.createElement(MediaManagerPhotoEditor_1.default, { picture: value || {}, onClose: closePhotoEditor, onSubmit: photoEditorSubmit })),
        React.createElement(media_manager_connector_1.default, { mediaManagerBaseUrl: config_1.default.MEDIAMANAGER_URL, opened: mediamanagerOpened, appSpace: auth.appSpace, appId: auth.appId, accessToken: auth.token, onClose: closeMediaManager, onError: closeMediaManager, onUnauthorized: closeMediaManager, onSelectFiles: handleMediaManagerFilesSelect, multiple: false }),
        mediamanagerOpened ? (React.createElement(Loader_1.default, null)) : (React.createElement(React.Fragment, null,
            value && (React.createElement(ImageContainer, { onClick: openMediaManager },
                React.createElement(StyledMediaManagerImage, { naturalWidth: IMAGE_HEIGHT * 3, naturalHeight: 0, picture: value, script: "media" }))),
            !disabled && (React.createElement(Controls, null,
                React.createElement("span", null),
                React.createElement(Link_1.default, { primary: true, onClick: openMediaManager }, utilities_1.__('Vybrať obrázok')),
                value && (React.createElement(React.Fragment, null,
                    React.createElement(Link_1.default, { onClick: openPhotoEditor }, utilities_1.__('Upraviť')),
                    React.createElement(Link_1.default, { danger: true, onClick: clear }, utilities_1.__('Odstrániť')))),
                React.createElement("span", null))))),
        disabled && React.createElement(Disabled, null)));
};
exports.default = C;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
